import escapeForRegex from "./escapeForRegex";

const encodedSymbolMap: Record<string, string> = {
  "'": "&#39;",
  '"': "&quot;",
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
};

const dangerousSymbolRegEx = new RegExp(
  `[${escapeForRegex(Object.keys(encodedSymbolMap).join(""))}]`,
  "g"
);

const escapeForHtml = (dangerousText: string): string =>
  dangerousText.replace(
    dangerousSymbolRegEx,
    (matchedSymbol: string) => encodedSymbolMap[matchedSymbol] ?? ""
  );

export default escapeForHtml;
